<!-- eslint-disable -->
<template>
  <div class="G_modal">
    <modal-header
      @event-close-child-modals="eventCloseChildModals"
      @event-close-modal="closeSelfModal"
      :title="modalTitle">
    </modal-header>
    <div class="p2s2m1_grid1_container">
      <div class="p2s2m1_meta_fields_container">
        <label class="p2s2m1_name_label"></label>
        <input 
          class="p2s2m1_name_field p2s2m1_input_field" 
          v-model="ruleName" 
          placeholder="Rule Name" 
          type="text"
        >
        <label class="p2s2m1_description_label"></label>
        <input 
          class="p2s2m1_input_field" 
          v-model="ruleDescription" 
          placeholder="Rule Description (optional)" 
          type="text"
        >
      </div>
      <div class="p2s2m1_condition_entries">
        <p2s2m1c1-condition-entry
          v-for="(condition,condition_index) in ruleLogic"
          :key="condition_index"
          :conditionEntry="condition"
          :conditionIndex="condition_index"
          :description="condition['description']"
          :operator="condition['operator']"
          @event-remove-condition="eventRemoveCondition"
          @event-condition-changed="eventConditionChanged"
          @pass-event-add-sub-condition="eventAddSubCondition"
          @pass-event-remove-sub-condition="eventRemoveSubCondition"
          @pass-event-sub-condition-changed="eventSubConditionChanged"
          :hideOperatorFlag="condition_index < 1"
        ></p2s2m1c1-condition-entry>
      </div>

      <div class="p2s2m1_bottom_buttons">
        <button @click="AddCondition" class="p2s2m1_add_condtion_button"></button>
        <button @click="saveRule" class="p2s2m1_save_button"></button> 
        <button @click="closeSelfModal" class="p2s2m1_cancel_button"></button> 
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../p2ModalHeader";
import { bi10ModalTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import editCreateRule from "../../../watchdog_includes/json_tasks/p2s7/p2s7t5";
import p2s2m1c1ConditionEntry from './p2s2m1/p2s2m1c1ConditionEntry'


export default {
  name: "p2s2m1CreateModifyRule",
  components: {
    ModalHeader,
    p2s2m1c1ConditionEntry,
  },
  mixins: [bi10ModalTemplate],
  // createEditFlag - 'edit' , 'create' are flags
  props: ["ruleUid", "createEditFlag", "isGroupRule", 'selectedRuleToEdit'],
  data: function() {
    return {
      ruleName: null,
      ruleDescription: null,
      ruleLogic: [],
      modalTitle: "Edit Notification Rule",
    };
  },
  mounted: function() {
    if (this.createEditFlag === 'create') {
      this.AddCondition(); 
    }

    if (this.isGroupRule && this.selectedRuleToEdit !== null && this.selectedRuleToEdit !== undefined) {
      this.ruleName = this.selectedRuleToEdit.name;
      this.ruleDescription = this.selectedRuleToEdit.description;
      if (Array.isArray(this.selectedRuleToEdit.ruleLogic) === false) {
        this.AddCondition();
      } else {
          this.ruleLogic = this.selectedRuleToEdit.ruleLogic;
        }
    } else if (this.ruleUid !== null && this.ruleUid !== undefined) {
      this.ruleName = window.G_watchdog_data.IV_notification_rules[this.ruleUid]["name"];
      this.ruleDescription = window.G_watchdog_data.IV_notification_rules[this.ruleUid]["description"];
      var rule_logic = JSON.parse(window.G_watchdog_data.IV_notification_rules[this.ruleUid]["UI_json_data"]);
      // a rule in an older format start with an empty rule
      if (Array.isArray(rule_logic) === false) {
        this.AddCondition();      
      } else {
        this.ruleLogic = rule_logic;
      }
    }

  },

  methods: {
    AddCondition: function() {
      this.ruleLogic.push({
        type: "condition",
        description: null,
        operator: "or",
        sub_conditions: [{ type: "sub_condition", operator: "", value:null }],
      });
    },
    eventAddSubCondition: function(condition_index) {
      this.ruleLogic[condition_index]["sub_conditions"].push({ type: "sub_condition", operator: "", value:null });
    },

    eventRemoveCondition: function(condition_index) {
      this.ruleLogic.splice(condition_index, 1);
    },
    eventRemoveSubCondition: function(args) {
      var condition_index = args[0];
      var sub_condition_index = args[1];
      this.ruleLogic[condition_index]["sub_conditions"].splice(sub_condition_index, 1);
    },
    eventSubConditionChanged: function(args) {
      var condition_index = args[0];
      var sub_condition_index = args[1];
      var operator = args[2][0];
      var value = args[2][1];

      this.$set(this.ruleLogic[condition_index]["sub_conditions"][sub_condition_index], "operator", operator);
      if (value !== undefined && value !== null) {
        this.$set(this.ruleLogic[condition_index]["sub_conditions"][sub_condition_index], "value", value.toLowerCase());
      }
    },
    eventConditionChanged: function(args) {
      var condition_index = args[0];
      var operator = args[1][0];
      var description = args[1][1];
      this.$set(this.ruleLogic[condition_index],"operator", operator);
      this.$set(this.ruleLogic[condition_index],"description", description);
    },
    saveRule: function() {
      if (this.ruleDescription === null) {
        this.ruleDescription = " ";
      }
      if (this.isGroupRule != undefined && this.isGroupRule != null && this.isGroupRule == true) {
        let ruleData = {
          name: this.ruleName,
          description: this.ruleDescription,
          rule_logic: JSON.stringify(this.ruleLogic),
        }
        this.$emit("create-new-group-rule", ruleData);
        return;
      }
      editCreateRule(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        this.ruleName,
        this.ruleDescription,
        JSON.stringify(this.ruleLogic),
        this.createEditFlag,
        this.ruleUid
      );
      this.closeSelfModal();

      console.log(JSON.stringify(this.ruleLogic));
    },
    closeSelfModal() {
      this.ruleName = null;
      this.ruleDescription = null;
      this.ruleLogic = [];
      
      if (this.isGroupRule == true) {
        this.$emit("hide-create-group-rule-modal");
      } else {
        this.selfClose();
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m1CreateModifyRule.vue